import { RotateCcw, Home } from "lucide-react";
import { Avatar, Confetti } from "../ui";
import Scoreboard from "./Scoreboard";

const REASONS = {
  eliminados: "Todos los impostores fueron eliminados.",
  sin_inocentes: "Ya no quedan inocentes en pie.",
  adivino: "El impostor adivinó la palabra secreta.",
};

export default function End({ game, board, onNew, onMenu }) {
  const good = game.winner === "inocentes";
  return (
    <div className={`screen end ${good ? "end-good" : "end-bad"}`}>
      {good ? <Confetti /> : <div className="red-pulse" data-testid="impostor-win-overlay" />}
      <header className="end-head">
        <span className="eyebrow">Fin de la partida</span>
        <h1 className={`title ${good ? "txt-inocente" : "txt-impostor"}`} data-testid="winner-title">
          {good ? "Ganan los inocentes" : "Ganan los impostores"}
        </h1>
        <p className="muted" data-testid="winner-reason">{REASONS[game.reason]}</p>
      </header>

      <section className="glass section words-reveal" data-testid="end-words">
        <div><span className="muted small">Palabra secreta</span><strong className="txt-inocente" data-testid="end-normal-word">{game.pair.normal}</strong></div>
        <div><span className="muted small">Impostor</span><strong className="txt-impostor" data-testid="end-impostor-word">{game.mode === "parecida" ? game.pair.impostor : "Sin palabra"}</strong></div>
        <div className="full-col"><span className="muted small">Categoría: {game.pair.categoria}</span></div>
      </section>

      <ul className="roles" data-testid="end-roles">
        {game.players.map((p, i) => (
          <li key={p.name} className={`glass role-row role-${p.role}`} data-testid={`end-player-${i}`}>
            <Avatar name={p.name} size="sm" dead={!p.alive} />
            <span className={`grow${p.alive ? "" : " struck"}`}>{p.name}</span>
            <span className="role-tag">{p.role === "impostor" ? "Impostor" : "Inocente"}</span>
          </li>
        ))}
      </ul>

      <Scoreboard board={board} delta={game.delta} />

      <div className="actions row">
        <button className="btn btn-ghost btn-xl" onClick={onMenu} data-testid="end-menu-btn"><Home size={20} /> Menú</button>
        <button className="btn btn-primary btn-xl grow" onClick={onNew} data-testid="new-game-btn"><RotateCcw size={20} /> Nueva partida</button>
      </div>
    </div>
  );
}
